import { render, staticRenderFns } from "./DashboardKPIBox.vue?vue&type=template&id=76b7caa4&scoped=true"
import script from "./DashboardKPIBox.vue?vue&type=script&lang=js"
export * from "./DashboardKPIBox.vue?vue&type=script&lang=js"
import style0 from "./DashboardKPIBox.vue?vue&type=style&index=0&id=76b7caa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7caa4",
  null
  
)

export default component.exports